import { render, staticRenderFns } from "./SegmentationTable.vue?vue&type=template&id=f652401e"
import script from "./SegmentationTable.vue?vue&type=script&lang=js"
export * from "./SegmentationTable.vue?vue&type=script&lang=js"
import style0 from "./SegmentationTable.vue?vue&type=style&index=0&id=f652401e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports